import React, { useState } from 'react'
import LoadingButton from '../shared/LoadingButton'
import LoginMethodFrame, {
  LoginMethodContentsOnSubmitProps,
} from '../shared/LoginMethodFrame'
import TermsCheckbox from '../shared/TermsCheckbox'
import { preventDefaultAndValidate } from '../../helpers'
import {
  InjectedSigninMethodProps,
  withSigninMethodProps,
} from '../../context/withSigninMethodProps'

const PureSigninPasswordContents = ({
  recaptchaPromise,
  recaptchaLoading,
  onSubmit,
  email,
  requiresTermsAgreement,
  termsAgreed,
  onTermsAgreementChange,
}: LoginMethodContentsOnSubmitProps & {
  requiresTermsAgreement: boolean
  termsAgreed: boolean
  onTermsAgreementChange: (agreed: boolean) => void
}) => {
  const [password, setPassword] = useState('')

  const submitSignin = async (e: React.MouseEvent<HTMLButtonElement>) => {
    onSubmit(password)
    setPassword('') // Reset the password input
  }

  return (
    <>
      <div>
        <label
          htmlFor="password"
          className="block mb-2 text-sm font-medium text-gray-900"
        >
          Password
        </label>
        <input
          type="text"
          name="email"
          value={email}
          autoComplete="username"
          readOnly
          hidden
        />
        <input
          onChange={(e) => setPassword(e.target.value)}
          value={password}
          autoFocus
          tabIndex={1}
          type="password"
          name="password"
          id="password"
          placeholder="••••••••"
          autoComplete="current-password"
          className="bg-gray-50 border border-gray-300 text-gray-900 rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5"
          required
        />
      </div>
      {requiresTermsAgreement && (
        <TermsCheckbox
          checked={termsAgreed}
          onChange={onTermsAgreementChange}
          tabIndex={2}
        />
      )}
      <LoadingButton
        loading={recaptchaLoading}
        onClick={preventDefaultAndValidate(submitSignin)}
        tabIndex={requiresTermsAgreement ? 3 : 2}
        type="submit"
        className="w-full text-white bg-slate-600 hover:bg-slate-700 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center"
      >
        Sign in
      </LoadingButton>
    </>
  )
}

type PureSigninPasswordProps = {
  recaptcha?: boolean
} & InjectedSigninMethodProps

export const PureSigninPassword = ({
  onSubmit,
  email,
  requiresTermsAgreement,
  termsAgreed,
  onTermsAgreementChange,
  ...props
}: PureSigninPasswordProps) => (
  <LoginMethodFrame
    title="Sign in with password"
    recoveryPrompt="Forgotten your password?"
    {...{ email, ...props }}
  >
    <PureSigninPasswordContents
      {...{
        onSubmit,
        email,
        requiresTermsAgreement,
        termsAgreed,
        onTermsAgreementChange,
      }}
    />
  </LoginMethodFrame>
)

export const SigninPassword = withSigninMethodProps(PureSigninPassword)

export default SigninPassword
